import React, { Component, Fragment } from "react";
import { connect } from "@common/components/base.component";
import Button from "@material-ui/core/Button";
import historicoActions from "../store/historico.actions";
import historicoSelector from "../store/historico.selectors";
import { Row, Col } from "react-bootstrap";
import autoBind from "react-autobind";
import Panel from "@common/externos/components/panel/panel.component";
import Grid from "./historico.grid";
import ModalHistorico from "./historico.modal";

class Container extends Component {
  constructor(props) {
    super(props);
    autoBind(this);

    this.state = {
      showModal: false
    }
  }

  render() {
    const { prefix, form, disableAll } = this.props;
    const isView = prefix == "V";
    const { showModal } = this.state;

    return (
      <Fragment>
        <ModalHistorico form={form} show={showModal} onClose={() => this.setState({ showModal: false })} prefix={prefix} isView={isView} />

        <Panel title={"Histórico"} defaultExpanded={false}>
          <Row className={"mb-4"}>
            <Col>
              <Button
                variant="contained"
                color="primary"
                disabled={disableAll}
                onClick={() => this.setState({ showModal: true })}
              >
                Novo Histórico
                <i className={"fas fa-plus ml-2"} />
              </Button>
            </Col>
          </Row>
          <Row>
            <Col>
              <Grid isView={disableAll} />
            </Col>
          </Row>
        </Panel>
      </Fragment>
    );
  }
}

export default connect({
  selectors: {
    historicoSelector
  },
  actions: {
    historicoActions
  }
})(Container);
